import React from 'react';
import { fetchOrders } from '../../../redux/actionCreators';
import { connect } from 'react-redux';
import Spinner from '../Spinner/Spinner';

const mapDispatchToProps = dispatch => {
    return {
        fetchOrders: (token, userId) => dispatch(fetchOrders(token, userId)),
    }
}
const mapStateToProps = state => {
    return {
        orders: state.orders,
        orderLoading: state.orderLoading,
        errMsg: state.errMsg,
        orderError: state.orderError,
        token: state.token,
        userId: state.userId
    }
}

//Single Order Decoration



const Order = props => {

    let ingredientSummary = props.order.ingredients.map(item => {
        return <span key={item.type}
            style={{
                border: '1px solid grey',
                boxShadow: '1px 1px #888888',
                borderRadius: '5px',
                padding: '5px',
                marginRight: '10px'

            }}>{item.amount} <b>x</b>  {item.type} </span>
    })
    return (
        <div
            style={{
                border: '1px solid grey',
                boxShadow: '1px 1px #888888',
                borderRadius: '5px',
                padding: '20px',
                marginBottom: '10px'


            }}>
            <p>Order Number : {props.order.id}</p>
            <p>Delivery Address : {props.order.customer.deliveryAddress}</p>
            <hr />
            <p>{ingredientSummary}</p>
            <hr />
            <p style={{ fontSize: '20px' }}><b>Total Price</b>: <span style={{ fontFamily: 'georgia' }}>{props.order.price} BDT</span></p>
        </div>
    )
}



class Orders extends React.Component {

    componentDidMount() {
        this.props.fetchOrders(this.props.token, this.props.userId);
    }
    render() {
        document.title = 'Orders'
        let orders = null;
        if (this.props.orderError) {
            orders = <p style={{
                backgroundColor: '#888888',
                padding: '20px',
                marginTop: '50px',
                borderRadius: '5px',

            }}>Order Loading is failed for <span style={{ backgroundColor: 'grey', padding: '0px 5px', color: 'wheat' }}>{this.props.errMsg}</span></p>
        } else {
            orders = this.props.orders.map(order => {
                return <Order order={order} key={order.id} />
            })
        }

        return (
            <div className='col-md-7 m-auto'>
                {
                    this.props.orderLoading ? <Spinner /> : orders
                }
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Orders);